const CUSTOM_REPLACEMENTS = [
  { pattern: /ß/gi, value: "ss" },
  { pattern: /æ/gi, value: "ae" },
  { pattern: /œ/gi, value: "oe" },
];

const stripDiacritics = (value) => {
  if (!value) return "";
  let output = value.toString().normalize("NFD");
  CUSTOM_REPLACEMENTS.forEach(({ pattern, value: replacement }) => {
    output = output.replace(pattern, replacement);
  });
  return output.replace(/[\u0300-\u036f]/g, "");
};

const collapseHyphens = (value) =>
  value.replace(/-+/g, "-").replace(/^-|-$/g, "");

const sanitizeSegment = (value) => {
  if (!value) return "";
  const stripped = stripDiacritics(value);
  if (!stripped) return "";
  const lowered = stripped.toLowerCase();
  return collapseHyphens(lowered.replace(/[^a-z0-9]+/g, "-"));
};

export const buildTenantSlug = (tenant) => {
  if (!tenant) return "";

  const idPart =
    tenant.id !== undefined && tenant.id !== null
      ? String(tenant.id).replace(/[^0-9]/g, "")
      : "";

  const namePart = sanitizeSegment(tenant.name || tenant.slug || "");

  const parts = [];
  if (idPart) parts.push(idPart);
  if (namePart) parts.push(namePart);
  const slug = collapseHyphens(parts.join("-"));
  if (slug) return slug;
  return idPart || "";
};

export default buildTenantSlug;
